// extracted by mini-css-extract-plugin
export default {"container":"ServicesList_container__sEcu1","grid":"ServicesList_grid__3y7+e","text":"ServicesList_text__Uw4J9","error":"ServicesList_error__hzCko"};